import { gql } from '@apollo/client';

export const CREATE_ADS_WITH_CREATIVES_OPERATION_ERROR_FIELDS = gql`
  fragment CreateAdsWithCreativesOperationErrorFields on CreateAdsWithCreativesOperationError {
    code
    message
  }
`;
